module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescirp5-bc2c1327e21f0e8098b82b8351c118ab.jpg";